/* Banner clicable — BigStudio.
   Hace que TODA la diapositiva del slideshow sea clicable cuando tiene un
   enlace (el <a class="ml-slide-link"> que renderiza la sección). No depende
   de z-index ni de que el <a> reciba el clic: escucha el clic en la propia
   diapositiva, así funciona pase lo que pase por encima.
   No corre en el editor de temas (ahí Shopify bloquea la navegación). */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  function bind() {
    var links = document.querySelectorAll('.ml-slide-link');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var slide = link.closest('.slideshow__slide');
      if (!slide || slide.dataset.mlBannerBound) continue;
      slide.dataset.mlBannerBound = '1';
      slide.style.cursor = 'pointer';

      (function (slide, href) {
        var sx = 0, sy = 0;
        slide.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
        slide.addEventListener('click', function (e) {
          // respeta los controles del slider y cualquier botón/CTA real
          if (e.target.closest('button, .slideshow__controls, .banner__buttons a')) return;
          // ignora si fue un arrastre, no un clic
          if (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10) return;
          window.location.href = href;
        });
      })(slide, link.href);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
